import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UtilState } from './utils.state';

export interface DownloadInfo {
    fileName: string;
    url: string;
}

const selectUtilState = createFeatureSelector<UtilState>('util');

const selectUtilUI = createSelector(
    selectUtilState,
    (state: UtilState) => state.ui
);
export const selectUtilData = createSelector(
    selectUtilState,
    (state: UtilState) => state.data
);

export const selectDowndloadInfo = createSelector(
    selectUtilUI,
    (state: UtilState['ui']) => {
        return state.downloadInfo;
    }
);

export const selectQcHybridApp = createSelector(
    selectUtilData,
    (state: UtilState['data']) => state.application.idMap.campaigns
);
